import { createActions, createReducer } from 'reduxsauce';
export const { Types, Creators } = createActions({
	buscarMotoristas: [ 'payload' ],
	buscarMotoristasSucesso: [ 'payload' ],
	setMotoristaEdicao: [ 'payload' ]
});

const INIT_STATE = {
	motoristasLista: [],
	alertMessage: '',
	showMessage: false,
	motoristaEdicao: {}
};

const buscarSucesso = (state = INIT_STATE, action) => ({
	...state,
	motoristasLista: action.payload
});

const motoristaEdicao = (state = INIT_STATE, action) => ({
	...state,
	motoristaEdicao: action.payload
});


export default createReducer(INIT_STATE, {
	[Types.BUSCAR_MOTORISTAS_SUCESSO]: buscarSucesso,
	[Types.SET_MOTORISTA_EDICAO]: motoristaEdicao
});
